import Point from "./point";
const Pointpg = () => {
    return (
              <div className="">
<Point></Point>                   
=======
              </div>
            );
          }
export default Pointpg;
          